/**
 * ScoreBadge — renders parsed [RING N SCORE: X/100 · signal: Y · advance_ready: Z]
 * Tinted with the ring's accent color per craigmaloney.com brand system.
 */
export default function ScoreBadge({ score }) {
  if (!score) return null;
  const ringClass = `ring-${score.ring}`;
  return (
    <span
      data-testid={`score-badge-ring-${score.ring}`}
      className={`score-badge ${ringClass}`}
      title={`Ring ${score.ring} score: ${score.score}/100`}
    >
      RING {score.ring} · {score.score}/100 · {score.signal}
      {score.advance_ready ? " · CLEAR" : ""}
    </span>
  );
}
